const CookiePolicy = () => {
  return <p>Cookie Policy</p>
}

export default CookiePolicy